// extracted by mini-css-extract-plugin
export var label = "_cu-1";
export var reminder = "_cu-0";